import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import { CommonPipe } from '@pipes/common.pipe';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

@Component({
  selector: 'app-my',
  templateUrl: './my.component.html',
  styleUrls: ['./my.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class MyComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    dictDefaultMessage: "<i class='fa fa-pencil'></i>",
    maxFiles: 1
  };
  upload = false;
  response: any = [];
  res: any = [];
  member: any = [];
  component = "b";
  application = "member";
  pageLoading = true;
  name = "";
  cover = "";
  p_area = '';
  p_no = '';
  completion = 0;
  media_list: any = { 'photo': 'photos', 'audio': 'audios', 'video': 'videos', 'blog': 'blogs', 'group': 'groups', 'album': 'albums', 'channel': 'channels', 'playList': 'playLists', 'business': 'businesss', 'event': 'events', 'product': 'products' };
  my_list: any = { 'education': 'education', 'sports': 'sports', 'work': 'work' };
  constructor(public ngxSmartModalService: NgxSmartModalService, private _commonPipe: CommonPipe, private router: Router, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    let p = {
      'component': this.component,
      'application': this.application,
      'id': this._global.getSessionVal('id')
    };
    this._viewService.application(p).subscribe(
      data => {
        this.pageLoading = false;
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.response = this._global.getVal(data, 'response', '');
          this.completion = this._global.getProfileCompletion(this.response);
          this.name = this._global.getVal(this.response, 'firstName', '') + "  " + this._global.getVal(this.response, 'lastName', '');
          this.cover = this._commonPipe.transform(this.response, ['image', 'cover', 'id', 'name', 'l']);
          this.p_area = this._global.getVal(this.response, 'phone.phone.area', '');
          this.p_no = this._global.getVal(this.response, 'phone.phone.number', '');
          this.res = {
            firstName: this._global.getVal(this.response, 'firstName', ''),
            lastName: this._global.getVal(this.response, 'lastName', ''),
            id: this._global.getVal(this.response, 'id', ''),
            bio: this._global.getVal(this.response, 'bio', {})
          };
          this.member = {
            firstName: this._global.getVal(this.response, 'firstName', ''),
            lastName: this._global.getVal(this.response, 'lastName', ''),
            id: this._global.getVal(this.response, 'id', ''),
            countryCode: this._global.getVal(this.response, 'countryCode', ''),
            phone: this._global.getVal(this.response, 'phone', '')
          }
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  @ViewChild('profileimg') public profileimg: ElementRef;
  @ViewChild('coverimg') public coverimg: ElementRef;
  ngOnInit() {

  }


  gotoMedia(a) {
    this.router.navigate(['/my/' + a]);
  }
  updateStatus() {
    this.ngxSmartModalService.getModal('memberstatus').open()
  }
  edit() {
    this.ngxSmartModalService.getModal('memberedit').open();
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, this._global.getSessionVal('id'));
  }
  public onUploadError(args: any): void {
    this.upload = false;
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    this.upload = false;
    this.profileimg.nativeElement.src = this._commonPipe.transform(this.response, ['image', this.application, 'id', 'firstName', 'm']);

  }
  public onSending(args: any): void {
    this.upload = true;
  }
  public oncSending(args: any): void {
    this.upload = true;
  }
  public oncUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'cover', this._global.getSessionVal('id'));
  }
  public oncUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
    this.upload = false;
  }

  public oncUploadSuccess(args: any): void {
    this.cover = this._commonPipe.transform(this.response, ['image', 'cover', 'id', 'name', 'l']);
    this.upload = false;
  }
}
